import { useTranslation } from "react-i18next";
import useUser from "../UserProvider/useUser";
import { notify } from "react-notify-toast";
import { Button, Icon } from "semantic-ui-react";
import { saveFile } from "../../../services/File/File.service";
import { exportPosAvailabilities } from '../../../services/PointOfSale/PointOfSale.service'

export const ExportPosOpeningButton = () => {

    const { user } = useUser();
    const [t] = useTranslation();

    const handleExportPosAvailabilities = async () => {
        try {
            const { data } = await exportPosAvailabilities(user.companyId)
            saveFile(t('administration.hours.export_pos_hours_file'), data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        } catch (e) {
            notify.show(t('global.anErrorOccurred'), 'error');
        }
    }

    return (
        <Button size="tiny"
            onClick={handleExportPosAvailabilities}
                        >
            <Icon name="download cloud" />
              {t('administration.hours.export_pos_hours')}
        </Button>
    )
}
